/**
 * Constants for map clustering
 */

/**
 * Default map bounds (world bounds)
 */
export const DEFAULT_MAP_BOUNDS: [number, number, number, number] = [-180, -90, 180, 90];

/**
 * Debounce delay for map view updates to prevent excessive API calls
 * Increased from 300ms to 500ms to reduce clustering calculations during pan/zoom
 */
export const MAP_VIEW_DEBOUNCE_DELAY = 500;
